// extracted by mini-css-extract-plugin
export var textWrapper = "Disclaimer-module--text-wrapper--0b00a";